import React, { } from "react";
import logo from "./../assets/img/BAbianco.png"
import { Layout } from "antd";
const { Content, Header } = Layout;

const TopBarHome = ({ children }) => {

  return (
    <Layout style={{ height: '100vh', backgroundColor:'white', overflow:'hidden' }}>
      <Header style={{ backgroundColor: '#003897' }}>
        
        <img src={logo} alt="Banco Azzoaglio" width={160}  style={{ padding: 5, marginBottom: 5 }}/>
      </Header>
      <Content style={{overflowY:'scroll'}}>
        {children}
      </Content>
    </Layout >


  );
};

export default TopBarHome;
